import { useDispatch } from 'react-redux';
import { fetchNewsroomNews } from '@client/content/redux/newsroom/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useFetchNewsroomNews = (): typeof fetchNewsroomNews => {
  const dispatch = useDispatch();

  return bindActionCreators(fetchNewsroomNews, dispatch);
};
